import React from 'react';
import ReactDOM from 'react-dom/client';

import Controller from './Controller';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import {Provider} from "react-redux";
import {persistor, store} from './component/redux/store';
import {PersistGate} from "redux-persist/integration/react";




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <Controller />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
);

reportWebVitals();

